export const CHAT_BOT_SCOPES = ['chat-bot', 'user-close-account'];
//# sourceMappingURL=authScopes.js.map